/* eslint-disable complexity */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable no-irregular-whitespace */
import { logger } from '@mail-core/logger';
import { Text } from '@vkontakte/vkui';
import React from 'react';
import { moveMessages } from 'reactApp/api/axios.corsapi';
import {
    MoveAllToSafeAPICall,
    MoveToSafeAPICall,
    RemoveFromSafeAPICall,
    RestoreFromSafeAPICall,
    SafeApiErrors,
} from 'reactApp/api/safe/safeApi';
import { safeCheckIsEmpty } from 'reactApp/appHelpers/featuresHelpers/features/overquotaSafe';
import { quotaCleanerSafeCheckIsEmpty } from 'reactApp/appHelpers/featuresHelpers/features/quotaCleanerSafe';
import { renderComfirmationDialog, renderMessageBox } from 'reactApp/components/BaseConfirmDialog/BaseConfirmDialog.helpers';
import { EButtonType } from 'reactApp/components/BaseConfirmDialog/BaseConformationDialog.types';
import { openBuyForSafe } from 'reactApp/components/BuyForSafe/BuyForSafe';
import { PaymentUTM } from 'reactApp/constants/paymentUTM';
import { sendDwhDialog, sendDwhRadar } from 'reactApp/modules/dwh/dwh.helpers';
import { getPaySource } from 'reactApp/modules/payment/payment.analytics';
import { openTariffBuy } from 'reactApp/modules/payment/payment.module';
import { productsController } from 'reactApp/modules/products/products.controller';
import { updateProducts } from 'reactApp/modules/products/products.module';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { resetSelected } from 'reactApp/modules/selections/selection.saga';
import { SelectionsSelectors } from 'reactApp/modules/selections/selections.selectors';
import { showSnackbarAction } from 'reactApp/modules/snackbar/snackbar.actions';
import { SnackbarTypes } from 'reactApp/modules/snackbar/snackbar.types';
import { getStorageSelectedItems } from 'reactApp/modules/storage/storage.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { SafeSource } from 'reactApp/modules/trashbin/safe.helpers';
import {
    moveToSafeRequest,
    moveToSafeSuccess,
    removeFromSafeRequest,
    restoreFromSafeRequest,
    trashbinLoad,
    trashbinSafeSetRestoreButtonVisible,
    trashbinSafeSetSize,
} from 'reactApp/modules/trashbin/trashbin.module';
import { getSafeSize } from 'reactApp/modules/trashbin/trashbin.selectors';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { updateUser } from 'reactApp/modules/user/user.thunkActions';
import { waitForUserUpdate } from 'reactApp/modules/user/waitForUserUpdate';
import { reloadGroupAfterDelete, setNeedsGroupReload } from 'reactApp/modules/userQuotaCleaner/userQuotaCleaner.actions';
import { QuotaCleanerSelectors } from 'reactApp/modules/userQuotaCleaner/userQuotaCleaner.selectors';
import type { QuotaCleanerItem } from 'reactApp/modules/userQuotaCleaner/userQuotaCleaner.types';
import { goToPromoQuota } from 'reactApp/sections/QuotaLanding/QuotaLanding.helpers';
import { store as reduxStore } from 'reactApp/store';
import type { Product } from 'reactApp/types/Billing';
import { UserQuotaGroupType } from 'reactApp/types/QuotaCleaner';
import { renderSafePromoDialog } from 'reactApp/ui/Toolbar/Move2SafeButton/SafePromoDialog';
import { preloadSafePromoDialogCover, SafePromoType } from 'reactApp/ui/Toolbar/Move2SafeButton/SafePromoDialog.helpers';
import { sendDwh, sendXray } from 'reactApp/utils/ga';
import { getPlatformInfo } from 'reactApp/utils/gaHelpers';
import { captureException } from 'reactApp/utils/tracer';
import { channel } from 'redux-saga';
import { call, put, select, take } from 'redux-saga/effects';

import { getGroupType } from '../userQuotaCleaner/helpers/getGroupType';
import { SAFE_FOLDER_ID } from './safe.constants';

const moveAllToSafeAPICall = new MoveAllToSafeAPICall().makeRequest;

const retryMove2SafePopup = (place) => {
    const name = 'error_files_to_safe';
    return renderComfirmationDialog({
        dataQAId: 'move-2safe-retry-dialog',
        renderHeader: () => (
            <div style={{ width: '390px' }}>
                Не&nbsp;удалось&nbsp;положить&nbsp;файлы
                <br />
                в&nbsp;сейф
            </div>
        ),
        successButtonText: 'Повторить попытку',
        actionButtonText: 'Закрыть',
        buttons: [EButtonType.accept, EButtonType.action],
        closeOnAction: true,
        smallButtons: true,
        renderContent: () => <Text style={{ fontSize: 18, lineHeight: '24px' }}>Повторите попытку чуть позже</Text>,
        onSuccess: () => {
            sendDwhDialog({ action: 'click', button_name: 'retry', name, place });
            setTimeout(() => reduxStore.dispatch(moveToSafeRequest()), 100);
        },
        onAction: () => {
            sendDwhDialog({ action: 'click', button_name: 'cancel', name, place });
        },
        onClose: () => sendDwhDialog({ action: 'close', name, place }),
        onShow: () => sendDwhDialog({ name, place }),
    });
};

const retryRestoreFromSafePopup = (place: string) => {
    const name = 'error_files_to_recover';

    return renderComfirmationDialog({
        dataQAId: 'restore-from-safe-retry-dialog',
        renderHeader: () => (
            <>
                Не удалось вернуть файлы
                <br />
                из сейфа
            </>
        ),
        successButtonText: 'Повторить попытку',
        actionButtonText: 'Закрыть',
        buttons: [EButtonType.accept, EButtonType.action],
        closeOnAction: true,
        smallButtons: true,
        renderContent: () => <Text style={{ fontSize: 18, lineHeight: '24px' }}>Повторите попытку чуть позже</Text>,
        onSuccess: () => {
            sendDwhDialog({ action: 'click', button_name: 'retry', name, place });
            setTimeout(() => reduxStore.dispatch(restoreFromSafeRequest()), 100);
        },
        onAction: () => {
            sendDwhDialog({ action: 'click', button_name: 'cancel', name, place });
        },
        onClose: () => sendDwhDialog({ action: 'close', name, place }),
        onShow: () => sendDwhDialog({ name, place }),
    });
};

const getSnackbarText = (place: SafeSource, cleanerGroup: ReturnType<typeof QuotaCleanerSelectors.getCurrentGroup> | null) => {
    if (place === SafeSource.CLEANER && cleanerGroup?.groupType === UserQuotaGroupType.Letter) {
        return 'Письма перемещены в сейф';
    }
    if (place === SafeSource.CLEANER) {
        return 'Файлы перемещены в сейф';
    }
    if (place === SafeSource.TRASHBIN) {
        return 'Файлы из корзины — в сейфе';
    }
    return 'Файлы перемещены в сейф';
};

const getSafePromoType = (
    place: SafeSource,
    cleanerGroup: ReturnType<typeof QuotaCleanerSelectors.getCurrentGroup>
): SafePromoType | null => {
    if (place === SafeSource.CLEANER && quotaCleanerSafeCheckIsEmpty && cleanerGroup?.groupType === UserQuotaGroupType.Letter) {
        return SafePromoType.afterMoveCleanerLetters;
    }

    if (place === SafeSource.CLEANER && quotaCleanerSafeCheckIsEmpty) {
        return SafePromoType.afterMoveCleanerFiles;
    }

    if (place === SafeSource.TRASHBIN && safeCheckIsEmpty) {
        return SafePromoType.afterMoveTrashbinFiles;
    }

    return null;
};

export function* moveToSafeHandle(action: ReturnType<typeof moveToSafeRequest>) {
    const storage = yield select(getCurrentStorage);
    const place: SafeSource = storage === EStorageType.trashbin ? SafeSource.TRASHBIN : SafeSource.CLEANER;
    const email = yield select(UserSelectors.getEmail);
    const cleanerGroup: ReturnType<typeof QuotaCleanerSelectors.getCurrentGroup> = yield select(QuotaCleanerSelectors.getCurrentGroup);
    const isQuotaCleaner = place === SafeSource.CLEANER;

    const safePromoType = getSafePromoType(place, cleanerGroup);

    if (safePromoType) {
        preloadSafePromoDialogCover(safePromoType);
    }

    try {
        const selectedItems: QuotaCleanerItem[] = yield select(getStorageSelectedItems, storage);
        const selectedItemsIds: ReturnType<typeof SelectionsSelectors.getSelectedIdxs> = yield select(SelectionsSelectors.getSelectedIdxs);

        const paths =
            place === SafeSource.CLEANER ? selectedItemsIds : selectedItemsIds?.map((file) => `/:trash/${file.split('/').at(-1)}`);

        // сейфуем файлы из корзины или файлы из чистилки
        let apiCall = paths?.length ? () => new MoveToSafeAPICall().makeRequest({ paths }) : () => moveAllToSafeAPICall();

        if (place === SafeSource.CLEANER && cleanerGroup?.groupType === UserQuotaGroupType.Letter) {
            // сейфуем письма из чистилки
            apiCall = () =>
                moveMessages(
                    email,
                    selectedItems.map((item) => item.deleteId),
                    SAFE_FOLDER_ID
                );
        }

        const resp = yield call(apiCall);

        if (resp?.status === 200) {
            yield put(
                showSnackbarAction({
                    closable: true,
                    id: 'move-to-safe-success',
                    type: SnackbarTypes.success,
                    text: getSnackbarText(place, cleanerGroup),
                })
            );

            sendDwh({
                eventCategory: 'safe',
                action: 'add',
                dwh_enabled: true,
                dwh_enabled_fields: [['place', ...(isQuotaCleaner ? ['group_id', 'group_type'] : []), 'platform']],
                dwhData: {
                    group_id: isQuotaCleaner ? cleanerGroup?.groupId : undefined,
                    group_type: isQuotaCleaner ? getGroupType(cleanerGroup?.groupId) : undefined,
                    count_files: selectedItemsIds?.length ?? undefined,
                    place,
                    platform: getPlatformInfo().join('_'),
                },
            });

            yield resetSelected();
            if (place === SafeSource.CLEANER && action.payload) {
                yield put(reloadGroupAfterDelete(action.payload));
                yield put(setNeedsGroupReload({ value: true }));
            } else {
                yield put(trashbinLoad());
            }

            yield put(moveToSafeSuccess());

            yield put(updateUser());

            if (safePromoType === SafePromoType.afterMoveCleanerLetters || safePromoType === SafePromoType.afterMoveCleanerFiles) {
                const safeSize = selectedItems.reduce((acc, item) => acc + item.size, 0);
                renderSafePromoDialog({ promoType: safePromoType, safeSize });
            } else if (safePromoType === SafePromoType.afterMoveTrashbinFiles) {
                yield take(trashbinSafeSetSize);

                const safeSize = yield select(getSafeSize);
                renderSafePromoDialog({ promoType: safePromoType, safeSize });
            }
        } else {
            retryMove2SafePopup(place);
        }
    } catch (error: any) {
        const responseError = error?.response?.error;

        logger.error(error);
        captureException(error, { issueKey: 'moveToSafe/error' });

        if (responseError === SafeApiErrors.SAFE_ERROR_ARCHIVE_LIMIT) {
            sendXray('safe-error_move_safe-full');

            yield processErrorNoSpace(place, true);

            return;
        }
        if (responseError === SafeApiErrors.SAFE_ERROR_NOT_OVERQUOTA) {
            sendXray('safe-error_move_bad-user');
            yield put(
                showSnackbarAction({
                    closable: true,
                    id: 'move-to-safe-fail2',
                    type: SnackbarTypes.failure,
                    text: 'Пользователь не в оверквоте',
                })
            );
            return;
        }

        sendXray(`safe-error_move_others_${responseError || 'unk'}`);

        retryMove2SafePopup(place);
    }
}

function* processErrorNoSpace(place: string, isMoveError = false) {
    yield productsController.loadProducts();

    const channelBuy = channel();

    const name = isMoveError ? 'not_enought_place_to_safe' : 'not_enought_place_to_recover';

    renderComfirmationDialog({
        dataQAId: 'restore-safe-no-space-dialog',
        renderHeader: () => (
            <div style={{ width: '390px' }}>
                {isMoveError ? (
                    <>
                        Перенести файлы нельзя —<br />
                        сейф заполнен
                    </>
                ) : (
                    <>
                        Файлам из сейфа не хватает
                        <br />
                        места
                    </>
                )}
            </div>
        ),
        successButtonText: 'Выбрать тариф',
        actionButtonText: 'Закрыть',
        buttons: [EButtonType.accept, EButtonType.action],
        closeOnAction: true,
        smallButtons: true,
        renderContent: () => (
            <Text style={{ fontSize: 18, lineHeight: '24px' }}>
                {isMoveError ? (
                    <>
                        Сейф вмещает 1 ТБ файлов,
                        <br />
                        всё не поместится. Увеличьте место
                        <br />в Облаке, и сейф не понадобится
                    </>
                ) : (
                    <>
                        Файлы вернутся в Облако, но сейчас
                        <br />
                        они не помещаются — добавьте место
                        <br />с подпиской Mail Space
                    </>
                )}
            </Text>
        ),
        onSuccess: () => {
            sendDwhDialog({ name, action: 'click', button_name: 'choose_tarif', place });

            if (place === SafeSource.TRASHBIN) {
                openBuyForSafe({
                    onShow: () => sendDwhRadar({ t: 'tariffs-quota', name: 'safe_recover', source: place }),
                    onBuyClick: (product) => channelBuy.put(product),
                });
            } else {
                goToPromoQuota({
                    currentPage: true,
                    query: PaymentUTM.quotaCleanerSafeRestore,
                });
            }
        },
        onClose: () => {
            channelBuy.put(false);
            sendDwhDialog({ name, action: 'click', button_name: 'cancel' });
        },
        onCancel: () => sendDwhDialog({ name, action: 'close', place }),
        onShow: () => sendDwhDialog({ name, place }),
    });

    const res = (yield take(channelBuy)) as Product | false;
    if (res) {
        const channelBuySuccess = channel();
        const channelClose = channel();

        yield put(
            openTariffBuy({
                productId: res.id,
                paySource: getPaySource(`safe_recover_${place}`),
                onSuccess: () => channelBuySuccess.put(true),
                onClose: () => channelClose.put(true),
            })
        );

        if (yield take(channelBuySuccess)) {
            yield take(channelClose);

            yield put(updateProducts());
            yield waitForUserUpdate();

            yield put(restoreFromSafeRequest());
        }
        channelBuySuccess.close();
        channelClose.close();
    }
    channelBuy.close();
}

const renderEmptySafeDialog = (place: string) =>
    renderMessageBox({
        dataQAId: 'safe-restore-empty',
        renderHeader: () => 'В сейфе пока пусто',
        cancelButtonText: 'Закрыть',
        renderContent: () => (
            <Text style={{ fontSize: 18, lineHeight: '24px' }}>Положите в него файлы из корзины — они сохранятся, а место не займут</Text>
        ),
        onClose: () => sendDwhDialog({ action: 'close', place, name: 'safe_is_empty' }),
        buttons: [EButtonType.cancel],
    });

export function* restoreFromSafeHandle() {
    const place = (yield select(getCurrentStorage)) === EStorageType.trashbin ? SafeSource.TRASHBIN : SafeSource.CLEANER;

    try {
        const res = yield new RestoreFromSafeAPICall().makeRequest();

        if (res?.data?.files_restored === 0) {
            renderEmptySafeDialog(place);
        } else {
            yield put(
                showSnackbarAction({
                    closable: true,
                    id: 'extract-from-safe-success',
                    type: SnackbarTypes.success,
                    text: 'Файлы из сейфа — снова в Облаке',
                })
            );

            yield put(trashbinSafeSetRestoreButtonVisible(false));

            sendDwh({ eventCategory: 'safe', action: 'restore', dwhData: { count_files: res?.data?.files_restored, place } });
        }
    } catch (error: any) {
        if (error?.response?.error === SafeApiErrors.SAFE_ERROR_EMPTY) {
            sendXray('safe-error_restore_empty-safe');
            sendDwhDialog({ place, name: 'safe_is_empty' });
            renderEmptySafeDialog(place);
            return;
        }

        if (error?.response?.error === SafeApiErrors.SAFE_ERROR_N_SPACE) {
            sendXray('safe-error_restore_no-space');
            yield processErrorNoSpace(place);
            return;
        }

        sendXray(`safe-error_restore_no-others_${error?.response?.error || 'unk'}`);

        retryRestoreFromSafePopup(place);
    }
}

export function* removeFromSafeRequestHandle() {
    const place = (yield select(getCurrentStorage)) === EStorageType.trashbin ? SafeSource.TRASHBIN : SafeSource.CLEANER;

    try {
        const res = yield new RemoveFromSafeAPICall().makeRequest();

        if (res?.status === 200) {
            yield put(
                showSnackbarAction({
                    closable: true,
                    id: 'remove-from-safe-success',
                    type: SnackbarTypes.success,
                    text: 'Все файлы из сейфа удалены',
                })
            );

            yield put(trashbinSafeSetRestoreButtonVisible(false));

            sendDwh({ eventCategory: 'safe', action: 'remove', dwhData: { place } });
        } else {
            sendXray('safe-error-restore-not200');
        }
    } catch (error: any) {
        sendXray('safe-error-restore', error?.response?.error || error?.response?.responseText);
    }
}

export function* renderRemoveFromSafeDialog() {
    const place = (yield select(getCurrentStorage)) === EStorageType.trashbin ? SafeSource.TRASHBIN : SafeSource.CLEANER;
    const name = 'safe-remove-modal';

    renderComfirmationDialog({
        dataQAId: 'safe-remove-files',
        renderHeader: () => 'Очистить сейф?',
        actionButtonText: 'Очистить навсегда',
        cancelButtonText: 'Не очищать',
        closeOnAction: true,
        isNegative: true,
        renderContent: () => (
            <Text style={{ fontSize: 18, lineHeight: '24px' }}>
                Файлы&nbsp;удалятся&nbsp;навсегда&nbsp;— восстановить&nbsp;их&nbsp;будет&nbsp;нельзя
            </Text>
        ),
        onClose: () => sendDwhDialog({ action: 'close', place, name }),
        onAction: () => {
            sendDwhDialog({ action: 'click', button_name: 'remove', name, place });
            setTimeout(() => reduxStore.dispatch(removeFromSafeRequest()), 100);
        },
        buttons: [EButtonType.action, EButtonType.cancel],
    });
}
